import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 获取所有分类
 */
export const getAllCategories = () => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/category/all`);
};

/**
 * 添加分类
 */
export const addCategory = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/category/add`, data);
};

/**
 * 编辑分类
 */
export const editCategory = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/category/edit`, data);
};

/**
 * 删除分类
 */
export const deleteCategory = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/category/del`, data);
};

/**
 * 获取分类详情
 */
export const getCategoryDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/category/detail`, params);
};

/**
 * 获取分类下的所有文章
 * @param {*} params
 * @returns
 */

export const getAllDocumentByCategory = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/category/list`, params);
};

/**
 * 获取文档列表
 */
export const getDocumentList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/record/list`, params);
};

/**
 * 获取所有文档
 */
export const getAllDocuments = () => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/record/all`);
};

/**
 * 添加文档
 */
export const addDocument = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/record/add`, data);
};

/**
 * 编辑文档
 */
export const editDocument = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/record/edit`, data);
};

/**
 * 删除文档
 */
export const deleteDocument = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/record/del`, data);
};

/**
 * 启用/禁用在线文档
 */
export const updateDocumentStatus = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/record/status`, data);
};

/**
 * 获取文档详情 by id
 */
export const getDocumentDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/record/detail`, params);
};

/**
 * 获取文档详情 by type
 */
export const getDocumentDetailByType = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/record/type`, params);
};

/**
 * 获取文档分页
 */
export const getDocumentPage = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/record/page`, params);
};

/**
 * 搜索文档
 */
export const searchDocument = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/record/search`, params);
};

/**
 * 新建分享
 */
export const createShare = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/share/new`, data);
};

/**
 * 获取分享详情
 */
export const getShareDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/share/get`, params);
};

/**
 * 获取分享扩展信息
 */
export const getShareExtra = params => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/share/x`, params);
};

/**
 * 获取历史记录
 */
export const getHistoryList = () => {
  return request('GET', `${baseUrl}/api/auth/sys/wiki/history/list`);
};

/**
 * 清空历史记录
 */
export const clearHistory = () => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/history/clear`);
};

/**
 * 保存文档内容
 */
export const saveDocumentContent = data => {
  return request('POST', `${baseUrl}/api/auth/sys/wiki/content/save`, data);
};
